import { leaveOnlyNumbers } from 'utils'

export default function formatZipCode(value: string) {
  const onlyNumbers = leaveOnlyNumbers(value)
  const [a, b, c, d, e] = onlyNumbers.split('')

  return `${a}${b}-${c}${d}${e}`
}
